import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Indoor_Cameras/IN-8815_QFHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "IN-8815 4K QFHD Objektivjustage",
  "path": "/Innenkameras/IN-8815_QFHD/Objektivjustage/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Einstellen des Focus bei Ihrer IN-8815 4K QFHD - die erste INSTAR Kamera mit dem neuen 2160p Chipsatz.",
  "image": "./P_SearchThumb_IN-8815QFHD_Lense_Adjust.webp",
  "social": "/images/Search/P_SearchThumb_IN-8815QFHD_Lense_Adjust.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-8415WQHD_white.webp",
  "chapter": "Indoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='IN-8815 4K QFHD Objektivjustage' dateChanged='2017-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Einstellen des Focus bei Ihrer IN-8815 4K QFHD - die erste INSTAR Kamera mit dem neuen 2160p Chipsatz.' image='/images/Search/P_SearchThumb_IN-8815QFHD_Lense_Adjust.webp' twitter='/images/Search/P_SearchThumb_IN-8815QFHD_Lense_Adjust.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Indoor_Cameras/IN-8815_QFHD/Lense_Adjustment/' locationFR='/fr/Indoor_Cameras/IN-8815_QFHD/Lense_Adjustment/' crumbLabel="Lense" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "in-8815-4k-qfhd-handbuch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-8815-4k-qfhd-handbuch",
        "aria-label": "in 8815 4k qfhd handbuch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-8815 4K QFHD Handbuch`}</h2>
    <h3 {...{
      "id": "einstellen-des-fokus-ihrer-in-8815-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#einstellen-des-fokus-ihrer-in-8815-kamera",
        "aria-label": "einstellen des fokus ihrer in 8815 kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einstellen des Fokus Ihrer IN-8815 Kamera`}</h3>
    <p>{`Das IN-8815 4K QFHD Standardobjektiv hat eine Tiefenschärfe, die auf eine Entfernung von ca. 5 - 8m eingestellt ist. Sollte der gewünschte Bereich unscharf sein, müssen Sie das Objektiv entsprechend einstellen.`}</p>
    <p>{`Durch Drehen des Objektivs nach links oder rechts können Sie den Fokus auf den gewünschten Bereich einstellen. Schließen Sie den Netzadapter und das Netzwerkkabel der Kamera an. Öffnen Sie die Weboberfläche und verwenden Sie das mitgelieferte Werkzeug, um das Objektiv zu drehen, bis Sie ein klares, scharfes Bild erhalten.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "826px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/2964e84a0e5545f39356f386f4eb7c5d/6a6e9/INSTAR_IN-8415-WQHD_Lense_Adjustment.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "46.086956521739125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABF0lEQVQoz22Sy07EMAxF+/+fwIIfmBV7hBCrWbJCzIZBYhag8ujQ5uHEzkUO4yhTsOSmsU+v7aQDAJRSmputY/2+xbq42dA2p5We9uDFgUuBiFTvP2gFiVCYwSfGuEGTORGCAOFhi7fNBcbnA0S4daawGjMjxojEjOljwufLoeWMG3LOCN4jAwiP95i215jev8BEZ+OrmHLEgji+Yry6xLjbIYfYuCqoDxUVZuQCBMpIxyPKalwVTClBSkHyDvPtBt93N5D4GzNuUJCIqijFWN/XF2PVNVd5Zbtj7blBq4YQKqjmvYdz7g+oYsZpLHhXWeNsrSP3XSq0LMu/HWq+ji1SuXmez7psv425Ctu59VV7cRPu2V7wBwhBwtA4LO/QAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2964e84a0e5545f39356f386f4eb7c5d/e4706/INSTAR_IN-8415-WQHD_Lense_Adjustment.avif 230w", "/de/static/2964e84a0e5545f39356f386f4eb7c5d/d1af7/INSTAR_IN-8415-WQHD_Lense_Adjustment.avif 460w", "/de/static/2964e84a0e5545f39356f386f4eb7c5d/a194c/INSTAR_IN-8415-WQHD_Lense_Adjustment.avif 826w"],
              "sizes": "(max-width: 826px) 100vw, 826px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/2964e84a0e5545f39356f386f4eb7c5d/a0b58/INSTAR_IN-8415-WQHD_Lense_Adjustment.webp 230w", "/de/static/2964e84a0e5545f39356f386f4eb7c5d/bc10c/INSTAR_IN-8415-WQHD_Lense_Adjustment.webp 460w", "/de/static/2964e84a0e5545f39356f386f4eb7c5d/40616/INSTAR_IN-8415-WQHD_Lense_Adjustment.webp 826w"],
              "sizes": "(max-width: 826px) 100vw, 826px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2964e84a0e5545f39356f386f4eb7c5d/81c8e/INSTAR_IN-8415-WQHD_Lense_Adjustment.png 230w", "/de/static/2964e84a0e5545f39356f386f4eb7c5d/08a84/INSTAR_IN-8415-WQHD_Lense_Adjustment.png 460w", "/de/static/2964e84a0e5545f39356f386f4eb7c5d/6a6e9/INSTAR_IN-8415-WQHD_Lense_Adjustment.png 826w"],
              "sizes": "(max-width: 826px) 100vw, 826px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/2964e84a0e5545f39356f386f4eb7c5d/6a6e9/INSTAR_IN-8415-WQHD_Lense_Adjustment.png",
              "alt": "IN-8415 WQHD Objektivjustage",
              "title": "IN-8415 WQHD Objektivjustage",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      